// extracted by mini-css-extract-plugin
module.exports = {"container":"_56365793","header":"df71319c flex items-center f4 pb3 fw6 bb bb--solid b--black-10 mv0","body":"_343a5c94 pt3 normal"};